export default __webpack_public_path__ + "static/media/wsp.0f74af52.png";